<style lang="scss">
  @use "../../../../assets/css/global.scss" as *;
  @use "../../../../assets/css/_colors.scss" as *;
  @use "../../../../assets/css/_mixins.scss" as *;
  .tooltip-svelte {
    .tooltipContent {
      border-radius: 0.375rem;
      box-shadow: $subtle-shadow;
      line-height: 1.5;
      opacity: 1;
      padding: 0.625rem;
      pointer-events: auto;
      cursor: auto;
      position: absolute;
      z-index: 9999;
      height: fit-content;
      color: $text-black;

      b {
        font-weight: bold;
      }

      &.xPlacement {
        &Center {
          @include absolute-center-horizontal;
        }

        &left {
          right: 0;
        }

        &right {
          left: 0;
        }
      }

      &.yPlacement {
        &top {
          bottom: 100%;
          margin-bottom: 0.5rem;
        }

        &bottom {
          top: 100%;
          margin-top: 0.5rem;
        }
      }
    }
  }
</style>

<script>
  import { createEventDispatcher } from "svelte";

  export let yPlacement = "bottom";
  export let xPlacement = "left";
  export let width = "12rem";
  export let fontSize = "16px";
  export let backgroundColor = "white";
  export let color = "";
  export let style =
    "cursor: pointer; display: inline-block; position: relative;";
  export let additionalContentDivStyle = "";
  export let dispatchMouseEvents = false;
  export let hoverHoldTime = 150;

  let isHovered = false;
  let timer = null;

  const dispatch = createEventDispatcher();

  const colorStyle = color ? `color: ${color};` : "";
  let contentDivStyle = `font-size: ${fontSize}; width: ${width}; background-color: ${backgroundColor};${colorStyle}`;
  if (additionalContentDivStyle) {
    contentDivStyle += `; ${additionalContentDivStyle}`;
  }

  const handleTooltipMouseEnter = () => {
    if (dispatchMouseEvents) dispatch("tooltip-enter");
    if (timer) clearTimeout(timer);
    isHovered = true;
  };

  const handleTooltipMouseLeave = () => {
    if (dispatchMouseEvents) dispatch("tooltip-leave");
    if (hoverHoldTime) {
      timer = setTimeout(() => {
        isHovered = false;
      }, hoverHoldTime);
    } else {
      isHovered = false;
    }
  };
</script>

<div
  class="tooltip-svelte"
  {style}
  role="tooltip"
  on:mouseenter={handleTooltipMouseEnter}
  on:mouseleave={handleTooltipMouseLeave}
>
  <slot name="target" />
  {#if isHovered}
    <div
      class="tooltipContent yPlacement{yPlacement} xPlacement{xPlacement}"
      style={contentDivStyle}
    >
      <slot name="content" />
    </div>
  {/if}
</div>
